export const formatDate = (newDate: string) => {
  const options: { [key: string]: string } = { day: "numeric", month: "long", year: "numeric" };
  const date = new Date(newDate);
  return date.toLocaleDateString("ru-RU", options);
};

export const formatDateTime = (newDateTime: string) => {
  const options: { [key: string]: string } = {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  const dateTime = new Date(newDateTime);
  return new Intl.DateTimeFormat("ru-RU", options).format(dateTime);
};

export const formatMediasDateTime = (newMediasDate: string) => {
  const date = new Date(newMediasDate);
  const options: { [key: string]: string } = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const formattedDate = date.toLocaleString("ru-RU", options);
  const [datePart, timePart] = formattedDate.split(", ");
  const [time] = timePart.split(" ");
  const [hours, minutes, seconds] = time.split(":");
  const formattedTime = `${hours}:${minutes}:${seconds}`;
  const formattedDatePart = datePart.replace(/\./g, "/");
  return `${formattedTime} ${formattedDatePart}`;
};

export const formatHistoryDateTime = (newHistoryDate: string) => {
  const date = new Date(newHistoryDate);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const formattedDate = `${day < 10 ? "0" + day : day}.${month < 10 ? "0" + month : month
    }.${year}`;
  const formattedTime = `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
    }`;
  return `${formattedDate} ${formattedTime}`;
};

export const stateDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatUnloadingsDate = (dateTimeString: string) => {
  const dateObject = new Date(dateTimeString);
  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const year = dateObject.getFullYear();
  const hours = String(dateObject.getHours()).padStart(2, "0");
  const minutes = String(dateObject.getMinutes()).padStart(2, "0");
  const seconds = String(dateObject.getSeconds()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const formatInputsDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;
};

export const formatUnloadingsTime = (time: string) => {
  const [hours, minutes, seconds] = time.split(":");
  return `${hours}ч ${minutes}м ${seconds}с`;
};

export const getCorrectDate = (newDate: Date) => {
  const year = newDate.getFullYear();
  const month = String(newDate.getMonth() + 1).padStart(2, "0");
  const day = String(newDate.getDate()).padStart(2, "0");
  const hours = String(newDate.getHours()).padStart(2, "0");
  const minutes = String(newDate.getMinutes()).padStart(2, "0");
  const seconds = String(newDate.getSeconds()).padStart(2, "0");
  const milliseconds = String(newDate.getMilliseconds()).padStart(3, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
};

export const formatDefaultDateMonth = (date: Date) => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

export const formatDateForMapReport = (newDate: string) => {
  const date = new Date(newDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

export const formatDateWithDots = (newDate: string) => {
  const originalDate = new Date(newDate)
  const day = originalDate.getDate().toString().padStart(2, "0");
  const month = (originalDate.getMonth() + 1).toString().padStart(2, "0"); // +1, так как месяцы считаются с 0
  const year = originalDate.getFullYear();
  const hours = originalDate.getHours().toString().padStart(2, "0");
  const minutes = originalDate.getMinutes().toString().padStart(2, "0");
  return `${day}.${month}.${year} ${hours}:${minutes}`
}

// "2023-10-31T11:41:21" => кол-во минут
export const formatCheckIn = (date: string) => {
  const newDate = new Date(date)
  const hours = newDate.getHours()
  const minutes = newDate.getMinutes()
  const seconds = newDate.getSeconds()
  return (hours * 60) + minutes + (seconds / 60)
}

// "00:00:00" => кол-во минут
export const formatStartTime = (date: string) => {
  const timeParts = date.split(":");
  const hours = parseInt(timeParts[0]);
  const minutes = parseInt(timeParts[1]);
  const seconds = parseInt(timeParts[2]);
  return (hours * 60) + minutes + (seconds / 60)
}

// "00:00:00" -> "00:00"
export const formatTimeWoSeconds = (time: string) => {
  const convertedTime = time.slice(0, 5)
  return convertedTime
}